import React from 'react'
import { ReactComponent as SequenceEventIcon } from 'src/assets/icons/paula-seq-event-icon.svg';
import { ReactComponent as FiltersIcon } from 'src/assets/icons/paula-filter-icon.svg';
import { getCleanMarkdownString } from 'src/components/SproutsAgent/utils';
interface PropsType {
  message: string
}
const CreateAgent: React.FC<PropsType> = ({ message }) => {
  const [refinedMessage, setRefinedMessage] = React.useState('');
  const getElement = (text: string) => {
    if (!text.trim()) return null;
    const json = JSON.parse(text.replace('json', '').trim());
    const [key, values] = Object.entries(json)[0];
    const isEvent = key === 'event';
    const WrapperClass = isEvent ? "events-wrapper" : "filters-wrapper";
    const Content = (item: string, index: number) => {
      const ItemClass = isEvent ? `event-container-${index + 1}` : `filters-container-${((index) % 5) + 1}`;
      return (
        <div key={index} className={ItemClass}>
          {isEvent ? (
            <>
              <div className="left">
                <p>{item}</p>
              </div>
              <div className="right">
                <SequenceEventIcon />
              </div>
            </>
          ) : (
            <>
              <span>{item}</span>
              <div className='sm-icon'><FiltersIcon /></div>
            </>
          )}
        </div>
      )
    };
    return (
      <div className={WrapperClass}>
        {values.map((item: string, index: number) => Content(item, index))}
      </div>
    );
  };

  const parseText = (texts: string) => {
    const text = texts.trim();
    const regex = text.split('```');

    const elements = regex.map((item, index) => {
      if (item?.includes('json')) {
        return getElement(item);
      }
      else {
        if (item.trim().length > 0) {
          const updatedItem = item.replaceAll("*", '');
          const sublines = updatedItem.split('\n');
          return sublines.map((line, lineIndex) => {
            if (line.includes('###')) {
              return <h6 key={`${index}-${lineIndex}`}>
                {line.replace('###', '')}
              </h6>
            }
            return (
              <p key={`${index}-${lineIndex}`}>
                {line}
              </p>
            );
          });
        }
        return null;
      }
    });

    return (
      <div>
        {elements}
      </div>
    );
  };

  React.useEffect(() => {
    const cleanMessage = getCleanMarkdownString(message);
    setRefinedMessage(cleanMessage);
  }, [message])
  return (
    <div className='create-agent-container'>
      {
        parseText(refinedMessage)
      }
    </div>
  )
}

export default CreateAgent;
